import {
  Radio,
  RadioGroup,
  FormControlLabel,
  Stack,
  styled,
} from "@mui/material";

const StyledRadio = styled(Radio)(({ theme }) => ({
  color: "#666666",
  padding: "12px",
  "&.Mui-checked": {
    color: "#FF6B00",
  },
  "& .MuiSvgIcon-root": {
    fontSize: 24,
  },
}));

const StyledFormControlLabel = styled(FormControlLabel)({
  "& .MuiFormControlLabel-label": {
    color: "#fff",
    fontSize: "16px",
    fontweight: 700,
  },
});

export default function CustomRadioGroup({ value, onChange, options }) {
  return (
    <RadioGroup value={value} onChange={(e) => onChange(e.target.value)}>
      <Stack direction="row" spacing={4}>
        {options.map((option) => (
          <StyledFormControlLabel
            key={option.value}
            value={option.value}
            control={<StyledRadio />}
            label={option.label}
          />
        ))}
      </Stack>
    </RadioGroup>
  );
}
